import axiosNew from '../../../helpers/axios'
import { cleanObject, cleanObjectNull } from '../../../helpers/queryBuilder'

export const getAllTaskLogList = async (
    data
) => {
    const { page,
        limit,
        start,
        end,
        projectId,
        userId, } = data

    return new Promise(async (resolve) => {
        const skip = page && limit ? (page - 1) * limit : 0

        const rawBody = {
            skip,
            limit,
            start,
            end,
            projectId,
            userId,
        }

        const body = cleanObject(rawBody)
        try {
            const res = await axiosNew({
                url: 'reports/user-timelog-list',
                method: 'POST',
                data: body,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            console.log(error, "error=====");

            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const getUserLogByID = async ({
    page,
    limit,
    start,
    end,
    projectId,
    userId,
}) => {
    return new Promise(async (resolve) => {
        const skip = page && limit ? (page - 1) * limit : 0

        const rawBody = {
            // skip,
            // limit,
            start,
            end,
            projectId,
            userId,
        }
        const body = cleanObject(rawBody)

        try {
            const res = await axiosNew({
                url: 'reports/project-timelog',
                method: 'POST',
                data: body,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const projectByUserId = async ({
    page,
    limit,
    userId,
}) => {
    const skip = page && limit ? (page - 1) * limit : 0;

    const params = {
        userId,
        skip,
        limit,
    };

    try {
        const res = await axiosNew.get('users/project-list', { params });
        return { data: res.data ?? {} };
    } catch (error) {
        return { data: error?.response?.data ?? {} };
    }
};

export const saveReports = async (payload) => {



    const body = cleanObject(payload)
    try {
        const res = await axiosNew({
            url: 'save-report/add',
            method: 'POST',
            data: body,
        })
        return { data: res.data ?? {} };
    } catch (error) {
        return { data: error?.response?.data ?? {} };
    }
};


export const uploadRepoertS3 = async (payload) => {
    let data = payload ?? {}
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: 'aws/upload-file',
                data,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}


export const uploadReportS3Url = async (file, url) => {
    try {
        const formData = new FormData();
        formData.append("file", file);  // Assuming the file is passed as 'file'
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": file.type,
            },
            body: file?.originFileObj ? file.originFileObj : file
            ,  // Directly sending the file as the body of the request
        });

        if (!response.ok) {
            throw new Error(`Failed to upload file: ${response.statusText}`);
        }
        return response
    } catch (error) {
        console.log("🚀 ~ uploadResumeS3Url ~ error:", error);
    }
}